'use client';
import * as React from 'react';

import createSvgIcon from './createSvgIcon';

const EmailRead = createSvgIcon(
  <path
    fillRule="evenodd"
    d="M22,10 L22,18 C22,19.2654386 21.2538079,20 20,20 L20,20 L4,20 C2.74619208,20 2,19.2654386 2,18 L2,18 L2,10 L8,14 L5.5,16 C4.76896788,16.6238769 5.36702741,17.4263512 6,17 L6,17 L10,14 L14,14 L18,17 C18.6566472,17.4727041 19.3774265,16.6775114 18.5,16 L18.5,16 L16,14 L22,10 Z M10,2.98333333 C11.5,2.00555556 12.5,2.00555556 14,2.98333333 L14,2.98333333 L21.0000569,9.33888889 L15,13 L9,13 L3,9.33888889 Z"
  />,
  'EmailRead'
);

export default EmailRead;
